(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-overlay]');
  const toast = document.querySelector('[data-toast]');
  const menu = document.querySelector('[data-mobile-menu]');
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const showToast = (message) => { if (!toast) return; toast.textContent = message; toast.classList.add('show'); setTimeout(() => toast.classList.remove('show'), 2200); };
  const openOverlay = () => { if (overlay) overlay.hidden = false; document.body.style.overflow = 'hidden'; };
  const closePanels = () => { drawer?.classList.remove('open'); drawer?.setAttribute('aria-hidden', 'true'); if (menu) menu.hidden = true; if (overlay) overlay.hidden = true; document.body.style.overflow = ''; };
  const openCart = () => { drawer?.classList.add('open'); drawer?.setAttribute('aria-hidden', 'false'); openOverlay(); };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-open]')) openCart();
    if (event.target.closest('[data-cart-close]') || event.target.closest('[data-overlay]')) closePanels();
    if (event.target.closest('[data-mobile-menu-open]')) { if (menu) menu.hidden = false; openOverlay(); }
    if (event.target.closest('[data-mobile-menu-close]')) closePanels();
    const change = event.target.closest('[data-cart-change]');
    if (change) updateLine(change.dataset.cartChange, Number(change.dataset.quantity));
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form.matches('[data-product-form]') || form.classList.contains('product-form'))) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add item.');
      await refreshCart();
      openCart();
      showToast('Added to your cart');
    } catch (error) { showToast(error.message); }
    finally { if (button) button.disabled = false; }
  });

  async function updateLine(key, quantity) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: key, quantity }) });
      if (!response.ok) throw new Error('Unable to update cart.');
      await refreshCart();
    } catch (error) { showToast(error.message); }
  }

  async function refreshCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const items = document.querySelector('[data-cart-items]');
    const total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    if (!items) return;
    if (!cart.items.length) { items.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a href="' + window.Shopify.routes.root + '#islands">Explore your island →</a></div>'; return; }
    items.innerHTML = cart.items.map(item => `
      <div class="cart-row" data-line-key="${item.key}">
        ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}">` : ''}
        <div><a href="${item.url}">${escapeHtml(item.product_title)}</a><small>${escapeHtml(item.variant_title || '')}</small><div class="cart-quantity"><button type="button" data-cart-change="${item.key}" data-quantity="${Math.max(0,item.quantity-1)}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${item.key}" data-quantity="${item.quantity+1}">+</button></div></div>
        <div><strong>${money(item.final_line_price)}</strong><button class="remove-line" type="button" data-cart-change="${item.key}" data-quantity="0">Remove</button></div>
      </div>`).join('');
  }
  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[char]));
})();

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-product-option]')) return;
  const section = event.target.closest('[data-product-section]');
  if (!section) return;
  const variantsNode = document.querySelector('[data-product-json]');
  if (!variantsNode) return;
  const variants = JSON.parse(variantsNode.textContent);
  const selected = Array.from(section.querySelectorAll('[data-product-option]')).map(el => el.value);
  const variant = variants.find(v => v.options.every((value, index) => value === selected[index]));
  const idInput = section.querySelector('[data-variant-id]');
  const addButton = section.querySelector('.product-form [type="submit"]');
  const price = section.querySelector('[data-product-price]');
  if (!variant) return;
  if (idInput) idInput.value = variant.id;
  if (addButton) { addButton.disabled = !variant.available; addButton.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
  if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(variant.price / 100);
  const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
});

// Caribbean Class v0.8 header and hero experience
(() => {
  const header = document.querySelector('[data-header]');
  const menuButton = document.querySelector('[data-mobile-menu-open]');
  const menu = document.querySelector('[data-mobile-menu]');
  const syncHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  menuButton?.addEventListener('click', () => menuButton.setAttribute('aria-expanded', 'true'));
  document.querySelector('[data-mobile-menu-close]')?.addEventListener('click', () => menuButton?.setAttribute('aria-expanded', 'false'));
  document.querySelector('[data-overlay]')?.addEventListener('click', () => menuButton?.setAttribute('aria-expanded', 'false'));

  document.querySelectorAll('[data-hero-slider]').forEach(slider => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (slider.dataset.autoplay === 'true' && !reduceMotion) {
        timer = window.setInterval(() => show(index + 1), Number(slider.dataset.interval) || 7000);
      }
    };
    slider.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(index + 1); start(); });
    slider.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
    dots.forEach(dot => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); start(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    show(0);
    start();
  });
})();

// Caribbean Class v1.1 — product gallery, quantity, wishlist and collection filters
(() => {
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      const index = thumb.dataset.galleryThumb;
      thumbs.forEach(item => item.classList.toggle('is-active', item === thumb));
      slides.forEach(slide => slide.classList.toggle('is-active', slide.dataset.gallerySlide === index));
    }));
  });

  document.addEventListener('click', event => {
    const section = event.target.closest('[data-product-section]');
    if (event.target.closest('[data-quantity-minus]') && section) {
      const input = section.querySelector('[data-quantity-input]');
      if (input) input.value = Math.max(1, Number(input.value || 1) - 1);
    }
    if (event.target.closest('[data-quantity-plus]') && section) {
      const input = section.querySelector('[data-quantity-input]');
      if (input) input.value = Math.max(1, Number(input.value || 1) + 1);
    }
    const wishlist = event.target.closest('[data-wishlist-button], .card-wishlist');
    if (wishlist) {
      wishlist.classList.toggle('is-active');
      wishlist.textContent = wishlist.classList.contains('is-active') ? '♥' : '♡';
    }
    if (event.target.closest('[data-sticky-add]')) {
      document.querySelector('[data-product-section] [data-add-to-cart]')?.click();
    }
    if (event.target.closest('[data-filter-open]')) {
      document.querySelector('[data-filter-panel]')?.classList.add('is-open');
      let overlay = document.querySelector('.collection-filter-overlay');
      if (!overlay) { overlay = document.createElement('button'); overlay.type = 'button'; overlay.className = 'collection-filter-overlay'; overlay.setAttribute('aria-label','Close filters'); document.body.appendChild(overlay); }
      document.body.style.overflow = 'hidden';
    }
    if (event.target.closest('[data-filter-close], .collection-filter-overlay')) {
      document.querySelector('[data-filter-panel]')?.classList.remove('is-open');
      document.querySelector('.collection-filter-overlay')?.remove();
      document.body.style.overflow = '';
    }
  });
})();

// Caribbean Class stabilized island journey + passport.
(() => {
  const STORAGE_KEY = 'caribbeanClassPassportV1';
  const preview = document.querySelector('[data-island-preview]');
  const previewPanel = preview?.querySelector('.island-preview-panel');
  const switcher = document.querySelector('[data-journey-switcher]');
  const passport = document.querySelector('[data-passport]');
  const dataNode = document.getElementById('CaribbeanClassIslandData');
  let islands = [];
  try { islands = JSON.parse(dataNode?.textContent || '[]'); } catch (_) { islands = []; }
  const byHandle = handle => islands.find(item => item.handle === handle);
  const normalise = value => String(value || '').trim().toLowerCase();
  const readVisited = () => {
    try { const v = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (_) { return []; }
  };
  const writeVisited = value => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (_) {} };
  let visited = readVisited();
  let activeHandle = '';
  let lastFocus = null;

  const lockBody = () => { document.body.style.overflow = 'hidden'; };
  const unlockBody = () => {
    if (!preview || preview.hidden) {
      if (!switcher || switcher.hidden) {
        if (!passport || passport.hidden) document.body.style.overflow = '';
      }
    }
  };

  const updatePassport = () => {
    const isVisited = name => visited.some(item => normalise(item) === normalise(name));
    const count = islands.filter(item => isVisited(item.name)).length;
    document.querySelectorAll('[data-passport-count]').forEach(node => node.textContent = `${count}/${islands.length || 6}`);
    document.querySelectorAll('[data-passport-stamp]').forEach(stamp => {
      const stamped = isVisited(stamp.dataset.passportStamp);
      stamp.classList.toggle('is-stamped', stamped);
      const status = stamp.querySelector('[data-passport-status]');
      if (status) status.textContent = stamped ? 'Passport stamped' : 'Not yet explored';
    });
    document.querySelectorAll('.island-choice[data-island-name]').forEach(choice => choice.classList.remove('is-visited'));
    const text = document.querySelector('[data-passport-progress-text]');
    const bar = document.querySelector('[data-passport-progress-bar]');
    if (text) text.textContent = `${count} of ${islands.length || 6} islands explored`;
    if (bar) bar.style.width = `${islands.length ? (count / islands.length) * 100 : 0}%`;
    const badge = document.querySelector('[data-passport-badge]');
    const message = document.querySelector('[data-passport-message]');
    let title = 'Begin Your Journey';
    let copy = 'Explore your first island to earn a Caribbean Class passport stamp.';
    if (count >= 1) { title = 'Caribbean Traveller'; copy = 'Your journey has begun. Keep exploring the cultures behind Caribbean Class.'; }
    if (count >= 3) { title = 'Island Explorer'; copy = 'You have explored half of the current Caribbean Journey.'; }
    if (count >= (islands.length || 6)) { title = 'Caribbean Ambassador'; copy = 'You have explored every launch island. More destinations can be added as Caribbean Class grows.'; }
    if (badge) badge.textContent = title;
    if (message) message.textContent = copy;
  };

  const markVisited = island => {
    if (!island) return;
    if (!visited.some(item => normalise(item) === normalise(island.name))) {
      visited.push(island.name);
      writeVisited(visited);
    }
    updatePassport();
  };

  const renderCulture = island => {
    const root = preview?.querySelector('[data-island-preview-culture]');
    if (!root) return;
    root.innerHTML = (island.culture || []).map(item => `<article><span aria-hidden="true">${item[0]}</span><div><h3>${item[1]}</h3><p>${item[2]}</p></div></article>`).join('');
  };
  const renderSayings = island => {
    const root = preview?.querySelector('[data-island-preview-sayings]');
    if (!root) return;
    root.innerHTML = (island.sayings || []).map(item => `<article><span aria-hidden="true">“</span><h3>${item[0]}</h3><p>${item[1]}</p></article>`).join('');
  };

  const openIsland = (handle, options = {}) => {
    const island = byHandle(handle);
    if (!island || !preview) return;
    activeHandle = handle;
    lastFocus = document.activeElement;
    const image = preview.querySelector('[data-island-preview-image]');
    if (image) { image.src = island.image; image.alt = island.name; }
    const set = (sel, value) => { const node = preview.querySelector(sel); if (node) node.textContent = value || ''; };
    set('[data-island-preview-name]', island.name);
    set('[data-island-preview-flag]', island.flag);
    set('[data-island-preview-motto]', island.motto);
    set('[data-island-preview-intro]', island.intro);
    set('[data-island-preview-story-heading]', island.storyHeading);
    set('[data-island-preview-story]', island.story);
    set('[data-island-preview-shop-heading]', island.shopHeading);
    const shop = preview.querySelector('[data-island-preview-shop]');
    if (shop) shop.textContent = `Shop ${island.name}`;
    renderCulture(island);
    renderSayings(island);
    preview.hidden = false;
    preview.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => preview.classList.add('is-open'));
    lockBody();
    previewPanel?.scrollTo({ top: 0, behavior: 'auto' });
    markVisited(island);
    if (!options.fromHash && history.pushState) history.pushState({ ccIsland: handle }, '', `#island-${handle}`);
    window.setTimeout(() => preview.querySelector('[data-island-close]')?.focus(), 80);
  };

  const closeIsland = (options = {}) => {
    if (!preview || preview.hidden) return;
    preview.classList.remove('is-open');
    preview.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => { preview.hidden = true; unlockBody(); }, 240);
    if (!options.keepHash && location.hash.startsWith('#island-') && history.pushState) history.pushState({}, '', `${location.pathname}${location.search}#islands`);
    activeHandle = '';
    if (lastFocus instanceof HTMLElement) lastFocus.focus({ preventScroll: true });
  };

  const openSwitcher = () => {
    if (!switcher) return;
    switcher.hidden = false;
    requestAnimationFrame(() => switcher.classList.add('is-open'));
    lockBody();
  };
  const closeSwitcher = () => {
    if (!switcher || switcher.hidden) return;
    switcher.classList.remove('is-open');
    window.setTimeout(() => { switcher.hidden = true; unlockBody(); }, 220);
  };
  const openPassport = () => {
    if (!passport) return;
    updatePassport();
    passport.hidden = false;
    requestAnimationFrame(() => passport.classList.add('is-open'));
    lockBody();
  };
  const closePassport = () => {
    if (!passport || passport.hidden) return;
    passport.classList.remove('is-open');
    window.setTimeout(() => { passport.hidden = true; unlockBody(); }, 220);
  };

  document.addEventListener('click', event => {
    const islandLink = event.target.closest('[data-island-open]');
    if (islandLink) {
      event.preventDefault();
      closeSwitcher();
      closePassport();
      const mobileMenu = document.querySelector('[data-mobile-menu]');
      if (mobileMenu && !mobileMenu.hidden) {
        mobileMenu.hidden = true;
        document.querySelector('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'false');
      }
      openIsland(islandLink.dataset.islandOpen);
      return;
    }
    if (event.target.closest('[data-island-close]')) { event.preventDefault(); closeIsland(); return; }
    if (event.target.closest('[data-journey-open]')) { event.preventDefault(); openSwitcher(); return; }
    if (event.target.closest('[data-journey-close]')) { event.preventDefault(); closeSwitcher(); return; }
    if (event.target.closest('[data-passport-open]')) { event.preventDefault(); openPassport(); return; }
    if (event.target.closest('[data-passport-close]')) { event.preventDefault(); closePassport(); return; }

    const islandAnchor = event.target.closest('a[href="#islands"], a[href$="/#islands"]');
    if (islandAnchor) {
      const target = document.getElementById('islands');
      if (target) {
        event.preventDefault();
        closeIsland({ keepHash: true });
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState({}, '', '#islands');
      }
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (passport && !passport.hidden) { closePassport(); return; }
    if (switcher && !switcher.hidden) { closeSwitcher(); return; }
    if (preview && !preview.hidden) closeIsland();
  });

  window.addEventListener('popstate', () => {
    const match = location.hash.match(/^#island-(.+)$/);
    if (match) openIsland(match[1], { fromHash: true });
    else closeIsland({ keepHash: true });
  });

  updatePassport();
  const initial = location.hash.match(/^#island-(.+)$/);
  if (initial) window.setTimeout(() => openIsland(initial[1], { fromHash: true }), 50);
})();



// Caribbean Class v1.6.4 — self-contained About and Contact routes.
(() => {
  const overlay = document.querySelector('[data-cc-info-overlay]');
  if (!overlay) return;
  const views = [...overlay.querySelectorAll('[data-cc-info-view]')];
  const closeButtons = overlay.querySelectorAll('[data-cc-info-close]');
  const openView = (name) => {
    if (!['about','contact'].includes(name)) return false;
    views.forEach(view => view.hidden = view.dataset.ccInfoView !== name);
    overlay.hidden = false;
    document.body.classList.add('cc-info-open');
    const heading = overlay.querySelector(`[data-cc-info-view="${name}"] h1`);
    if (heading) { heading.setAttribute('tabindex','-1'); heading.focus({preventScroll:true}); }
    return true;
  };
  const closeView = () => {
    overlay.hidden = true;
    views.forEach(view => view.hidden = true);
    document.body.classList.remove('cc-info-open');
    if (location.hash === '#about' || location.hash === '#contact') {
      history.replaceState(null, '', location.pathname + location.search);
    }
  };
  const syncFromHash = () => {
    const name = location.hash.replace('#','').toLowerCase();
    if (!openView(name) && !overlay.hidden) closeView();
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href$="#about"],a[href$="#contact"]');
    if (!link) return;
    const hash = link.getAttribute('href').split('#').pop().toLowerCase();
    if (link.href.startsWith(location.origin + '/#') || (location.pathname === '/' && ['about','contact'].includes(hash))) {
      event.preventDefault();
      history.pushState(null, '', '#' + hash);
      openView(hash);
    }
  });
  closeButtons.forEach(btn => btn.addEventListener('click', (e) => { if (e.target.closest('a')) return; closeView(); }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !overlay.hidden) closeView(); });
  window.addEventListener('hashchange', syncFromHash);
  window.addEventListener('popstate', syncFromHash);
  syncFromHash();
})();
